export default {"src":"/_next/static/media/airdrop-eligible-illustration.8b7a0313.svg","height":352,"width":263};